import { render, staticRenderFns } from "./BubsNavBar.vue?vue&type=template&id=a5efa210"
import script from "./BubsNavBar.vue?vue&type=script&lang=js"
export * from "./BubsNavBar.vue?vue&type=script&lang=js"
import style0 from "./BubsNavBar.vue?vue&type=style&index=0&id=a5efa210&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports